import { Input, FormGroup, Box, H2 } from '@bigcommerce/big-design';
import CountriesDropdown from './Fields/CountriesDropdown';
import StatesDropdown from './Fields/StatesDropdown';

export function ShippingAddressForm({ customer, setCustomer }) {
	const getCustomerValue = (name) => customer?.[name] ?? '';
	const getShippingAddressValue = (name) =>
		customer?.shipping_address?.[name] ?? '';
	const setCustomerInformation = (name, value) => {
		const customerCopy = { ...customer };
		customerCopy[name] = value;
		setCustomer({ ...customerCopy });
	};
	const setShippingAddressValue = (name, value) => {
		const addressData = { ...customer.shipping_address };
		addressData[name] = value;
		setCustomerInformation('shipping_address', addressData);
	};

	return (
		<Box padding="medium">
			<H2>Shipping Address</H2>
			<FormGroup>
				<Input
					label="Company"
					required
					type="text"
					value={getCustomerValue('company')}
					onChange={(e) =>
						setCustomerInformation('company', e.target.value)
					}
				/>
				<Input
					label="Street address"
					required
					type="text"
					value={getShippingAddressValue('address1')}
					onChange={(e) =>
						setShippingAddressValue('address1', e.target.value)
					}
				/>
				<Input
					label="City"
					required
					type="text"
					value={getShippingAddressValue('city')}
					onChange={(e) =>
						setShippingAddressValue('city', e.target.value)
					}
				/>
				<StatesDropdown
					getValue={getShippingAddressValue}
					setValue={setShippingAddressValue}
				/>
				<Input
					label="Zip/Postal Code"
					required
					type="text"
					value={getShippingAddressValue('postal_code')}
					onChange={(e) =>
						setShippingAddressValue('postal_code', e.target.value)
					}
				/>
				<CountriesDropdown
					getValue={getShippingAddressValue}
					setValue={setShippingAddressValue}
				/>
			</FormGroup>
		</Box>
	);
}
